module.exports = __webpack_public_path__ + "assets/img/projects_item1.340b29af.png";